import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country } from '@utils/country';

export interface Countrys {
  name: Name;
  cca2: string;
}

export interface Name {
  common: string;
  official: string;
  nativeName: { [key: string]: NativeName };
}

export interface NativeName {
  official: string;
  common: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountrysService {
  // Si deja de funcionar visitar la api https://restcountries.com
  readonly endpoint = 'https://restcountries.com/v3.1/all?fields=cca2,name';
  constructor(private readonly http: HttpClient) {}

  countries = [
    'AFGHANISTAN',
    'ALBANIA',
    'ALGERIA',
    'AMERICAN SAMOA',
    'ANDORRA',
    'ANGOLA',
    'ANGUILLA',
    'ANTARTICA',
    'ANTIGUA AND BARBUDA',
    'ARGENTINA',
    'ARMENIA',
    'ARUBA',
    'AUSTRALIA',
    'AUSTRIA',
    'AZERBAIJAN',
    'BAHAMAS',
    'BAHRAIN',
    'BANGLADESH',
    'BARBADOS',
    'BELARUS',
    'BELGIUM',
    'BELIZE',
    'BENIN',
    'BERMUDA',
    'BOLIVIA',
    'BOSNIA-HERZEGOVINA',
    'BOTSWANA',
    'BOUVET ISLAND',
    'BRASIL',
    'BRITISH INDIAN OCEAN TERRITORY',
    'BRUNEI DARUSSALAM',
    'BRUTHAN',
    'BULGARIA',
    'BURKINA FASO',
    'BURUNDI',
    'CAHAD',
    'CAMBODIA',
    'CAMEROON',
    'CANADA',
    'CAPE VERDE',
    'CAYMAN ISLANDS',
    'CENTRAL AFRICAN REPUBLIC',
    'CHILE',
    'CHINA',
    'CHRISTMAS ISLAND',
    'COCOS (KEELING) ISLANDS',
    'COLOMBIA',
    'COMOROS',
    'CONGO',
    'CONGO, THE DEMOCRATIC REPUBLIC OF THE',
    'COOK ISLANDS',
    'COSTA RICA',
    'COTE D´IVOIRE',
    'CROATIA',
    'CUBA',
    'CYPRUS',
    'CZECH REPUBLIC',
    'DENMARK',
    'DJIBOUTI',
    'DOMINICA',
    'DOMINICAN REPUBLIC',
    'EAST TIMOR',
    'ECUADOR',
    'EGYPT',
    'EL SALVADOR',
    'EQUATORIAL GUINEA',
    'ERITREA',
    'ESTONIA',
    'ETHIOPIA',
    'FAEROE ISLANDS',
    'FALKLAND ISLANDS (MALVINAS)',
    'FIJI',
    'FINLAND',
    'FRANCE',
    'FRENCH GUIANA',
    'FRENCH POLINESIA',
    'FRENCH SOUTHERN TERRITORIES',
    'GABON',
    'GAMBIA',
    'GEORGIA',
    'GERMANY',
    'GHANA',
    'GIBRALTAR',
    'GREECE',
    'GREENLAND',
    'GRENADA',
    'GUADELOUPE',
    'GUAM',
    'GUATEMALA',
    'GUERNSEY, C.I.',
    'GUINEA',
    'GUINEA-BISSAU',
    'GUYANA',
    'HAITI',
    'HEARD AND MCDONALD ISLANDS',
    'HOLY SEE (VATICAN CITY STATE)',
    'HONDURAS',
    'HONG KONG',
    'HUNGARY',
    'ICELAND',
    'INDIA',
    'INDONESIA',
    'IRAN (ISLAMIC REPUBLIC OF)',
    'IRAQ',
    'IRELAND',
    'ISLE OF MAN',
    'ISRAEL',
    'ITALY',
    'JAMAICA',
    'JAPAN',
    'JERSEY, C.I.',
    'JORDAN',
    'KAZAKHSTAN',
    'KENYA',
    'KIRIBATI',
    'KOREA, DEMOCRATIC PEOPLE´S REP. OF',
    'KOREA, REPUBLIC OF',
    'KUWAIT',
    'KYRGYZSTAN',
    'LAO PEOPLE´S DEMOCRATIC REPUBLIC',
    'LATVIA',
    'LEBANON',
    'LESOTHO',
    'LIBERIA',
    'LIBYAN ARAB JAMAHIRIYA',
    'LIECHTENSTEIN',
    'LITHUANIA',
    'LUXEMBOURG',
    'MACAU',
    'MACEDONIA, THE FORMER YOGOSLAV REPUBLIC. OF',
    'MADAGASCAR',
    'MALAWI',
    'MALAYSIA',
    'MALDIVES',
    'MALI',
    'MALTA',
    'MARSHALL ISLANDS',
    'MARTINIQUE',
    'MAURITANIA',
    'MAURITIUS',
    'MAYOTTE',
    'MEXICO',
    'MICRONESIA (FEDERATED STATES OF)',
    'MOLDOVA, REPUBLIC OF',
    'MONACO',
    'MONGOLIA',
    'MONSERRAT',
    'MOROCCO',
    'MOZAMBIQUE',
    'MYANMAR',
    'NAMIBIA',
    'NAURU',
    'NEPAL',
    'NETH. ANTILLES',
    'NETHERLANDS',
    'NEW CALEDONIA',
    'NEW ZEALAND',
    'NICARAGUA',
    'NIGER',
    'NIGERIA',
    'NIUE',
    'NORFOLK ISLAND',
    'NORTHERN MARIANA ISLANDS',
    'NORWAY',
    'OMAN',
    'PAKISTAN',
    'PALAU',
    'PALESTIAN TERRITORY, OCCUPIED',
    'PANAMA',
    'PANAMA CANAL ZONE',
    'PAPUA NEW GUINEA',
    'PARAGUAY',
    'PERU',
    'PHILIPPINES',
    'PITCAIRN',
    'POLAND',
    'PORTUGAL',
    'PUERTO RICO',
    'QATAR',
    'REUNION',
    'ROMANIA',
    'RUSSIAN FEDERATION',
    'RWANDA',
    'SAINT KITTS AND NEVIS',
    'SAINT LUCIA',
    'SAINT VINCENT AND THE GRENADINES',
    'SAMOA',
    'SAN MARINO',
    'SAO TOME AND PRINCIPE',
    'SAUDI ARABIA',
    'SENEGAL',
    'SEYCHELLES',
    'SIERRA LEONE',
    'SINGAPORE',
    'SLOVAKIA',
    'SLOVENIA',
    'SOLOMON ISLANDS',
    'SOMALIA',
    'SOUTH AFRICA',
    'SOUTH GEORGIA AND SOUTH SANWICH ISLANDS',
    'SPAIN',
    'SRI LANKA',
    'ST. HELENA',
    'ST. PIERRE AND MIQUELON',
    'SUDAN',
    'SURINAME',
    'SVALBARD AND JAN MAYEN ISLANDS',
    'SWAZILAND',
    'SWEDEN',
    'SWITZERLAND',
    'SYRIAN ARAB REPUBLIC',
    'TAIWAN',
    'TAJIKISTAN',
    'TANZANIA, UNITED REPUBLIC OF',
    'THAILAND',
    'TIMOR LESTE',
    'TOGO',
    'TOKELAU',
    'TONGA',
    'TRINIDAD AND TOBAGO',
    'TUNISIA',
    'TURKEY',
    'TURKMENISTAN',
    'TURKS AND CAICOS ISLANDS',
    'TUVALU',
    'UGANDA',
    'UKRAINE',
    'UNITED ARAB EMIRATES',
    'UNITED KINGDOM',
    'UNITED STATES',
    'UNITED STATES MINOR OUTLYING ISLANDS',
    'URUGUAY',
    'UZBEKISTAN',
    'VANUATU',
    'VENEZUELA',
    'VIETNAM',
    'VIRGIN ISLANDS (BRITISH)',
    'VIRGIN ISLANDS, US',
    'WALLIS AND FUTUNA ISLANDS',
    'WESTERN SAHARA',
    'YEMEN',
    'YOGOSLAVIA',
    'ZAIRE',
    'ZAMBIA',
    'ZIMBABWE',
  ];
  getCountrys() {
    return new Promise<Country[]>((resolve, reject) => {
      this.http.get<Countrys[]>(this.endpoint).subscribe({
        next: (countrys) => {
          const responseCountrys = countrys.map((country) => {
            return new Country(country);
          });

          resolve(responseCountrys);
        },

        error: (err) => {
          reject(err);
        },
      });
    });
  }
}
